import React, { useMemo } from "react";

import connect from "../../../../../../../i18n/connect";
import useIsDesktop from "../../../../hooks/useIsDesktop";
import {
  getPeriodToggleOptions,
  KNOWN_PERIODS
} from "../../../../../../../lib/Plans";
import { ToggleSelect } from "../ToggleSelect";

const BlackWeekToggleSelectPlan = ({
  translate,
  setPlan,
  plan,
  allowedPeriods = []
}) => {
  const isDesktop = useIsDesktop();

  const options = useMemo(() => {
    const yearlyTooltipLabel = translate(
      "lp_black-week_plan-table_yearly_toggle-select_tooltip"
    );

    return getPeriodToggleOptions({
      allowedPeriods,
      translate,
      labelKeysByPeriod: {
        [KNOWN_PERIODS.MONTHLY]:
          "lp_black-week_plan-table_monthly_toggle-select_label",
        [KNOWN_PERIODS.YEARLY]:
          "lp_black-week_plan-table_yearly_toggle-select_label"
      },
      yearlyTooltip: {
        tooltipTop: !isDesktop ? yearlyTooltipLabel : undefined,
        tooltipBottom: isDesktop ? yearlyTooltipLabel : undefined
      }
    });
  }, [allowedPeriods, isDesktop, translate]);

  return <ToggleSelect options={options} value={plan} onChange={setPlan} />;
};

export default connect()(BlackWeekToggleSelectPlan);
